import { List } from 'immutable';

import { logout as logUserOut } from 'utils/jwt';

import {
    BE_ME,
    BE_ME_FAIL,
    BE_ME_SUCCESS,
    BE_USER,
    BE_USER_FAIL,
    BE_USER_SUCCESS,
    CONFIRM_EMAIL,
    CONFIRM_EMAIL_FAIL,
    CONFIRM_EMAIL_SUCCESS,
    LOG_ME_IN,
    LOG_ME_IN_FAIL,
    LOG_ME_IN_SUCCESS,
    LOG_ME_OUT,
    REFRESH_TOKEN,
    REFRESH_TOKEN_FAIL,
    REFRESH_TOKEN_SUCCESS,
    REPLAY_FAILED_API_CALLS,
    REPLAY_FAILED_API_CALLS_SUCCESS,
    RESET_PASSWORD,
    RESET_PASSWORD_SUCCESS,
    RESET_PASSWORD_FAIL,
    STORE_FAILED_API_CALL,
} from './reducer';

export const beMe = () => ({
    payload: {
        request: {
            data: {},
            method: 'post',
            url: '/auth/be',
        },
    },
    types: [BE_ME, BE_ME_SUCCESS, BE_ME_FAIL],
});

export const beUser = (userId) => ({
    payload: {
        request: {
            data: { userId },
            method: 'post',
            url: '/auth/be',
        }
    },
    types: [BE_USER, BE_USER_SUCCESS, BE_USER_FAIL],
});

export const confirmEmail = (confirmationCode) => ({
    payload: {
        request: {
            data: { confirmationCode },
            method: 'post',
            url: '/users/confirm'
        },
    },
    types: [CONFIRM_EMAIL, CONFIRM_EMAIL_SUCCESS, CONFIRM_EMAIL_FAIL],
});

export const login = (fields) => ({
    payload: {
        request: {
            data: {
                email: fields.get('email'),
                password: fields.get('password'),
            },
            method: 'post',
            url: '/auth',
        },
    },
    types: [LOG_ME_IN, LOG_ME_IN_SUCCESS, LOG_ME_IN_FAIL],
});

export const logout = () => {
    logUserOut();

    return { type: LOG_ME_OUT };
};

export const storeFailedApiCall = (apiCall) => ({
    apiCall,
    type: STORE_FAILED_API_CALL,
});

export const replayFailedApiCalls = () => (dispatch, getState) => {
    const { auth } = getState();
    const promises = auth.get('failedApiCalls', List([])).toJS().map((apiCall) => {
        // eslint-disable-next-line
        apiCall.payload.request.headers = { Authorization: `Bearer ${auth.get('jwt')}` };
        return dispatch(apiCall);
    });

    // When all promises resolve, dispatch success action
    Promise.all(promises).then(() => dispatch({
        type: REPLAY_FAILED_API_CALLS_SUCCESS,
    }));

    return dispatch({ type: REPLAY_FAILED_API_CALLS });
};

export const refreshToken = () => (dispatch, getState) => {
    const token = getState().auth.get('jwt');

    if (token) {
        return dispatch({
            payload: {
                request: {
                    data: {
                        token: getState().auth.get('jwt'),
                    },
                    method: 'post',
                    url: '/auth/refresh',
                },
            },
            types: [REFRESH_TOKEN, REFRESH_TOKEN_SUCCESS, REFRESH_TOKEN_FAIL],
        }).then(() => {
            dispatch(replayFailedApiCalls());
        });
    }

    return dispatch(logout);
};

export const resetPassword = (data) => ({
    payload: {
        request: {
            data,
            method: 'post',
            url: '/users/reset',
        },
    },
    types: [RESET_PASSWORD, RESET_PASSWORD_SUCCESS, RESET_PASSWORD_FAIL],
});



// WEBPACK FOOTER //
// ./src/redux/auth/actions.js